export function makeSnilsValidation<T>(errorMsg: T, getException?: () => boolean) {
  // eslint-disable-next-line
  const re = /^\d{3}-\d{3}-\d{3}\s\d{2}$/;

  return (snils?: string) => {
    const isException = getException && getException();

    if (isException) {
      return undefined;
    }

    return re.test(String(snils).toLowerCase()) && checksumVerification(snils) ? undefined : errorMsg;
  };
}

function checksumVerification(checkedValue: string | undefined) {
  if (!checkedValue) {
    return false;
  }

  const onlyNums = checkedValue.replace(/\D/g, '');

  if (!onlyNums) {
    return false;
  }

  const checkSum = parseInt(onlyNums.slice(9), 10);

  const checkedValueArray = onlyNums.split('').map(Number);

  const sum =
    checkedValueArray[0] * 9 +
    checkedValueArray[1] * 8 +
    checkedValueArray[2] * 7 +
    checkedValueArray[3] * 6 +
    checkedValueArray[4] * 5 +
    checkedValueArray[5] * 4 +
    checkedValueArray[6] * 3 +
    checkedValueArray[7] * 2 +
    checkedValueArray[8];

  if (sum < 100 && sum === checkSum) {
    return true;
  }
  if ((sum === 100 || sum === 101) && checkSum === 0) {
    return true;
  }

  return sum > 101 && (sum % 101 === checkSum || (sum % 101 === 100 && checkSum === 0));
}
